export const selectRooms = (state) => state.rooms
